import { supabase } from '@/lib/supabase';

type FormNotificationType = 'epi' | 'incident' | 'denunciation';

interface FormNotificationPayload {
  formType: FormNotificationType;
  displayId: string;
  requesterName?: string;
  setor?: string;
  summary?: string;
}

export async function notifyFormSubmission(payload: FormNotificationPayload) {
  const { error } = await supabase.functions.invoke('send-form-notification', {
    body: payload,
  });

  if (error) {
    console.warn('Falha ao enviar e-mail de notificação:', error.message);
  }
}
